/* global $ */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import _ from 'lodash';

import './styles.scss';
import { modalViewGA } from '../../../utils/googleAnalytics';

class CamGroupInfoComponent extends Component {
  constructor(props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);
    this.watch = this.watch.bind(this);
  }

  closeModal(e) {
    e.preventDefault();
    this.props.removeModal();
  }

  watch(e) {
    e.preventDefault();
    this.props.removeModal();
    const url = this.props.camGroupInfo.url;

    const $navGroup = $('.nav-group');
    if ($navGroup.hasClass('is-locked')) {
      const combinedNavHeight = ($navGroup.outerHeight() + $('.nav-wrapper').outerHeight());
      $navGroup.css('top', -combinedNavHeight);
      _.delay(() => {
        $navGroup.removeClass('is-locked');
        $('body').css('margin-top', '0');
      }, 300);
    }

    this.context.router.push(url);
  }

  componentDidMount() {
    modalViewGA('camGroupInfo');
  }

  render() {
    const { camGroupInfo: { fullDesc, camGroupPoster, url, title } } = this.props;

    return (
      <div className="modals-popup camgroupinfo-modal u-font-foundation-roman">
        <div className="modal-header d-flex align-items-center">
          <div className="col">{title}</div>
          <div className="text-right">
            <a className="closer" href="#" onClick={this.closeModal}>{ }</a>
          </div>
        </div>
        <div className="info">
          <div className="text-justify intro-text">
            <Link to={url} onClick={e => this.watch(e)}><img className="camgroupinfo-poster float-right" src={camGroupPoster} width="140" height="210" alt="" /></Link>
            <p>{fullDesc}</p>
          </div>
        </div>
        <div className="text-center">
          <Link to={url} onClick={e => this.watch(e)} className="video-player-btn snapshot-gallery d-inline-block text-btn u-font-foundation-roman text-uppercase watch-now" >watch now</Link>
        </div>
      </div>
    );
  }

}
const mapStateToProps = (state) => {
  return {
    camGroupInfo: state.cam_groups.camGroupInfo,
  };
};

CamGroupInfoComponent.contextTypes = {
  router: PropTypes.object,
};

CamGroupInfoComponent.propTypes = {
  camGroupInfo: PropTypes.shape({
    url: PropTypes.string,
  }).isRequired,
  removeModal: PropTypes.func.isRequired,
};

export default connect(mapStateToProps)(CamGroupInfoComponent);
